import { render, staticRenderFns } from "./ProductsPreloader.vue?vue&type=template&id=3e36ffd5&lang=pug&"
import script from "./ProductsPreloader.vue?vue&type=script&lang=js&"
export * from "./ProductsPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports